module.exports = __webpack_public_path__ + "static/media/groot.3cccb21d.jpg";